// DialogService (Plan sharded-hatching-clover, Phase 3.2): Promise-Fassade
// ueber POS.message/POS.hourGlass, damit Domaenen-/Servicecode Fehler als
// Werte melden kann und die Dialog-Mechanik an EINER Stelle liegt. Die
// Legacy-Konvention darunter: POS.message.show(text, icon, buttons, cls,
// fnc) ruft fnc(cls, result) mit dem Button-Ergebnis ("Ja"/"Nein"/"OK"/
// "CANCEL"/...).
export const DialogService = {
  // Feuer-und-vergessen-Hinweis (OK-Knopf, niemand wartet).
  info(text) { POS.message.show(text, "info", "OK"); },
  warn(text) { POS.message.show(text, "warning", "OK"); },

  // Frage mit Ergebnis: loest mit dem Button-String auf.
  ask(text, icon, buttons) {
    return new Promise((resolve) => {
      POS.message.show(text, icon, buttons, null, (cls, result) => resolve(result));
    });
  },

  confirmYesNo(text) {
    return this.ask(text, "question", "YESNO").then((r) => r === "Ja");
  },

  busy(text) { POS.hourGlass.show(text); },
  idle() { POS.hourGlass.hide(); },
};
